import { render, staticRenderFns } from "./rateView.vue?vue&type=template&id=7dbfd7b2&"
import script from "./rateView.vue?vue&type=script&lang=js&"
export * from "./rateView.vue?vue&type=script&lang=js&"
import style0 from "./rateView.vue?vue&type=style&index=0&id=7dbfd7b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports